import { isAriResourceIdValid } from '@atlassian/ui-modifications-public-api-utils/is-ari-resource-id-valid';
import { isNotEmptyString } from '@atlassian/ui-modifications-public-api-utils/is-not-empty-string';

export const SET_VALUE_ARRAY_SIZE_LIMIT = 100;

export type MultiCheckboxSetPublicValue = string[];

// Interface for options used in transformers
export interface SelectOption {
    value: string;
    label: string;
}

// Interface for options visibility
export interface OptionsVisibility {
    options: string[];
    isVisible: boolean;
}

export const validateMultiCheckboxSetValue = (value: unknown): value is MultiCheckboxSetPublicValue =>
    Array.isArray(value) && value.length <= SET_VALUE_ARRAY_SIZE_LIMIT && value.every(isNotEmptyString);

export const validateMultiCheckboxWithAriSetValue = (value: unknown): value is MultiCheckboxSetPublicValue =>
    Array.isArray(value) &&
    value.length <= SET_VALUE_ARRAY_SIZE_LIMIT &&
    value.every((val) => isNotEmptyString(val) && isAriResourceIdValid(val));

export const multiCheckboxSetValueTransformer = (optionIds: string[], options: SelectOption[]) => {
    const selectedOptions = options.filter((option) => optionIds.includes(option.value));
    return selectedOptions;
};

export const multiCheckboxGetValueTransformer = (selectedOptionData: SelectOption[]) => {
    return selectedOptionData.map((option) => {
        return {
            id: option.value,
            value: option?.label,
        };
    });
};

export const multiCheckboxSetOptionsVisibilityTransformer = (
    optionsVisibility: OptionsVisibility,
    lookupValues?: SelectOption[]
) => {
    return lookupValues?.filter(({ value }) =>
        optionsVisibility.isVisible
            ? optionsVisibility.options.includes(value)
            : !optionsVisibility.options.includes(value)
    );
};

export const multiCheckboxGetOptionsVisibilityTransformer = (
    optionsVisibility: OptionsVisibility,
    lookupValues?: SelectOption[]
) => {
    const filteredLookupValues = lookupValues?.filter(({ value }) =>
        optionsVisibility.isVisible
            ? optionsVisibility.options.includes(value)
            : !optionsVisibility.options.includes(value)
    );
    return {
        options: filteredLookupValues?.map(({ value }) => value) ?? [],
        isVisible: optionsVisibility.isVisible,
    };
};

export const modifyMultiSelectValueToBasic = (selectedOptions: SelectOption[]) =>
    selectedOptions?.length > 0 ? selectedOptions.map((option) => option.value) : [];
